// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmTestimonialsSlider = function(options) {
		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			autoplay: true,
			autoplaySpeed: 7000,
			arrows: false,
			dots: true,
			fade: true,
			infinite: true,
			slidesToShow: 1,
			speed: 500

		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		// On load function.
		methods.initContext = function ($context) {
			methods.setCurrentSettings($context);

			$context.slick({
				autoplay: settings.autoplay,
				autoplaySpeed: settings.autoplaySpeed,
				arrows: settings.arrows,
				dots: settings.dots,
				fade: settings.fade,
				infinite: settings.infinite,
				slidesToShow: settings.slidesToShow,
				speed: settings.speed
			});
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));
		});
	};

	if($('#testimonials').length) {
		$('#testimonials').lmTestimonialsSlider();
	}

}(jQuery));
